const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const authHeaders = async (getToken) => {
  const token = await getToken();

  if (!token) return {};

  return {
    Authorization: `Bearer ${token}`,
    "Content-Type": "application/json",
  };
};

export const fetchCourseModules = async (getToken) => {
  const headers = await authHeaders(getToken);

  const res = await fetch(`${API_BASE_URL}/api/course/modules`, {
    headers,
  });

  let data = null;
  try {
    data = await res.json();
  } catch (_) {}

  if (!res.ok) {
    return { status: res.status, data };
  }

  return {
    status: res.status,
    data,
  };
};